import { AfterViewInit, Component, inject, OnInit } from "@angular/core";
import { FieldSelectedValue, FormFieldConfig, SECTION_TYPE, TabConfig } from "../../model/form.model";
import { PageContainerComponent } from "../../layout/page-container/page-container.component";
import { DealerTrainingBillingTitle, DealerTrainingBillingTabSchema } from "../../model/dealer-training-billing.model";
import { DYNAMIC_IDENTIFIER, LAYOUT_TYPE } from "../../model/common.model";
import { FieldNames, FieldTypesForOptions } from "../../model/form-fields.model";
import { GlobalApiService } from "../../services/global-api.service";
import { CommonUtils } from "../../utils/common.utils";
import { ReplaySubject, Subject } from "rxjs";
@Component({
  selector: 'app-dealers-training-billing',
  standalone: true,
  providers: [],
  imports: [PageContainerComponent],
  templateUrl: './dealers-training-billing.component.html',
  styleUrl: './dealers-training-billing.component.scss',
})
export class DealersTrainingBillingComponent implements OnInit , AfterViewInit {
  title: string = DealerTrainingBillingTitle;
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  tabConfig: Array<TabConfig> = DealerTrainingBillingTabSchema;
  private readonly globalService = inject(GlobalApiService);
  private readonly commonUtils = inject(CommonUtils)
  public globalFilterFields: FormFieldConfig[] = [];
  public globalChartsPayload = new ReplaySubject<any>(1); 
  public globalTitleFields = {
    [DYNAMIC_IDENTIFIER['globalyear']] : ""
  }

  ngOnInit() {
    this.initializeTab();
  }
  initializeTab(){
    this.tabConfig.forEach(tab => {
      tab['tabOnChangeSubject'] = new Subject();
      tab['tabOnChangeSubject'].subscribe(_tabChange=>{
        if(tab['type'] === SECTION_TYPE['Dashboard']){
          this.updateGlobalFilter(tab);
          setTimeout(() => this.updateDefaultChart());
        }

      })
      this.updateGlobalFilter(tab);
    })
  }
  updateGlobalFilter(tab:TabConfig) {
    if (tab['type'] === SECTION_TYPE['Dashboard']) {
      tab['inputs']['gridSchema']?.forEach(gridElm => {
        if (gridElm?.inputs) {
          if (gridElm['type'] === SECTION_TYPE['GlobalFilter']) {
            if (gridElm.inputs?.dynamicFormArray) {
              gridElm.inputs.dynamicFormArray.onButtonClicked = () => { }
              gridElm.inputs.dynamicFormArray.onControlValueChanged = this.globalFilterOnChange;
              if (gridElm.inputs.dynamicFormArray?.FieldsArray) {
                this.globalFilterFields = gridElm.inputs.dynamicFormArray.FieldsArray
              }
            }
          } else {
            gridElm.inputs.filterSchema ??= {};
            gridElm.inputs.filterSchema['globalPayloadSubject'] = this.globalChartsPayload;
            gridElm.inputs.filterSchema['globalTitleFields'] = this.globalTitleFields;
          }
        }
      })
    }
  }
  globalFilterOnChange = (event: FieldSelectedValue) => {
    let selectedField: FormFieldConfig | null = null;
    let year = "";
    let yearType = "";
    event?.FieldArray?.forEach(field => {
      if (field['isDependentOn'] === event['FieldName']) {
        field['selectedValue'] = '';
      } else if (field['fieldName'] === event['FieldName']) {
        selectedField = field;
        year = selectedField['selectedValue'];
        if(selectedField['fieldName']  === FieldNames['FiscalYear']){
          yearType = 'fiscal';
          this.globalTitleFields[DYNAMIC_IDENTIFIER['globalyear']] = `${selectedField['displayName']} ${year}-${Number(year)+1}`;
        }else{
          yearType = 'normal';
          this.globalTitleFields[DYNAMIC_IDENTIFIER['globalyear']] = year;
        }
        
      }
    })
    const filterPayload:FieldSelectedValue = {
      FieldName: selectedField?.['fieldName'] ?? '',
      Value: {
        body:{ year: year, yearType: yearType },
        title: structuredClone(this.globalTitleFields)
      }
    }
    this.globalChartsPayload.next(filterPayload);
  }
  async updateDefaultChart(){
      try {
        if(this.globalFilterFields && this.globalFilterFields.length>0){
          await this.updateOptionForFilterFields(this.globalFilterFields).then(() => {
          const selectedField = this.globalFilterFields?.find(field => field['fieldName'] === FieldNames['CalendarYear'] && field['selectedValue'])
            ?? this.globalFilterFields?.find(field => field['fieldName'] === FieldNames['FiscalYear'] && field['selectedValue'])
            ?? this.globalFilterFields?.find(field => field['selectedValue']);
            if (selectedField) {
            this.globalFilterOnChange({ FieldName: selectedField['fieldName'], Value: selectedField['selectedValue'], FieldArray: this.globalFilterFields })
            } else {
              const calendarYearField = this.globalFilterFields.find(field => field['fieldName'] === FieldNames['CalendarYear']);
              if (calendarYearField) {
                calendarYearField['selectedValue'] = calendarYearField['defaultValue'] || `${new Date().getFullYear()}`;
                this.globalFilterOnChange({
                  FieldName: calendarYearField['fieldName'],
                  Value: calendarYearField['selectedValue'],
                  FieldArray: this.globalFilterFields
                });
              }
            }
          })
        }
      } catch (e) {
        console.info(e)    
      }
  }
  async updateOptionForFilterFields(fieldArray: FormFieldConfig[]) {
    const updatePromises = fieldArray.map(async (filterField: FormFieldConfig) => {
      if (FieldTypesForOptions.includes(filterField['fieldType'])) {
        if (filterField['options'] && filterField['options'].length > 0) {
          this.commonUtils.setDefaultValueForOptionsField(filterField);
        } else {
          try {
            const options = await this.globalService.getOptionsForField(filterField['fieldName']);
            filterField['options'] = options;
            this.commonUtils.setDefaultValueForOptionsField(filterField);
          } catch (err) {
            console.info(err);    
            filterField['options'] = [];
          }
        }
      }
    });
    return Promise.all(updatePromises);
  }
  ngAfterViewInit() {
    this.updateDefaultChart()
  }
}
